// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { PatientInquiryApi } from '../types/patient-inquiry.types';
import { patientInquiryHttpApi } from './patient-inquiry.api';
import { patientInquiryMockApi } from './patient-inquiry.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const patientInquiryApi: PatientInquiryApi = useMock
  ? patientInquiryMockApi
  : patientInquiryHttpApi;
